<template>
  <a class="twitter-follow-button" href="https://twitter.com/MemCachier" data-show-count="false">
    Follow @MemCachier
  </a>
</template>

<script>
import twitterWidgetsAPI from "@/vendor/twitter-widgets.js";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AppSocial extends Vue {
  created() {
    twitterWidgetsAPI();
  }
}
</script>

<style scoped lang="scss"></style>
